export { default as BgClimate } from './BgClimate';
export { default as BgEnergy } from './BgEnergy';
export { default as BgFood } from './BgFood';
export { default as BgHealth } from './BgHealth';
export { default as BgNature } from './BgNature';
export { default as BgRessources } from './BgRessources';
